import { fireTag } from '@nuxt-common/util/app/utils/tagManager';
import { EVENT_TAGGING } from '../config';

export default function eventAnalyticsTagging(component, eventName, propObj = null) {
  const { EVENT_NAME, LINK_NAME, EVENT_TYPE } = EVENT_TAGGING?.[component]?.[eventName] || '';
  if (EVENT_NAME && LINK_NAME && EVENT_TYPE) {
    let eventObj = {};
    if (EVENT_TYPE === 'view') {
      eventObj = {
        page_name: EVENT_NAME,
        page_type: LINK_NAME,
      };
    } else {
      eventObj = {
        event_name: EVENT_NAME,
        link_name: LINK_NAME,
      };
    }
    if (propObj && propObj.constructor === Object && Object.keys(propObj).length > 0) {
      eventObj = {
        ...eventObj,
        ...propObj,
      };
    }
    fireTag(EVENT_TYPE, eventObj);
  }
}

export function eventAnalyticsFunctionTag(component, eventName, val) {
  const { EVENT_NAME, LINK_NAME, EVENT_TYPE } = EVENT_TAGGING?.[component]?.[eventName] || '';
  if (EVENT_NAME && LINK_NAME && EVENT_TYPE) {
    fireTag(EVENT_TYPE, {
      event_name: EVENT_NAME(val),
      link_name: LINK_NAME(val),
    });
  }
}

export function fireGlobalErrorTag(errorCode, message) {
  let linkTagObj = {
    event_name: 'my account error',
    error_code: [errorCode],
    error_category: 'my account',
    error_label: ['create_account_error'],
    error_message: [message],
    error_scope: ['global'],
    error_misc: ['check_email_address'],
  };
  if (Object.keys(errorCode || {}).length === 0 && !message) {
    linkTagObj = {
      account_action: 'two-factor authentication',
      link_loyalty_popup: true,
    };
  }
  fireTag('link', linkTagObj);
}
